/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_3_TitleInputs */

const en_mk_cap_3_title = /** @type {(inputs: Mk_Cap_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled routines`)
};

const id_mk_cap_3_title = /** @type {(inputs: Mk_Cap_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas terjadwal`)
};

/**
* | output |
* | --- |
* | "Scheduled routines" |
*
* @param {Mk_Cap_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_3_title = /** @type {((inputs?: Mk_Cap_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_3_title(inputs)
	return en_mk_cap_3_title(inputs)
});